import { createContext, useContext } from 'react';
import type { DesignConfiguration } from '@/lib/api/design';

export interface DesignContextType {
  config: DesignConfiguration;
  isLoading: boolean;
  applyDesignToDOM: (config: DesignConfiguration) => void;
  designError: string | null;
}

export const DesignContext = createContext<DesignContextType | undefined>(undefined);

export function useDesign(): DesignContextType {
  const context = useContext(DesignContext);
  if (context === undefined) {
    throw new Error('useDesign must be used within a DesignProvider');
  }
  return context;
}
